// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_gM","advertCardNum":"c-a_gN"};